 /*
创建者 魏强(2018.3.8)
精品直降
*/
<template>
<div class="mod-selling red">
    <h3 class="mod-selling-title"><span>精品直降</span></h3>
    <div class="swipe-optim">
        <div class="swipe-wrap">
        	<div class="swipe" id="swipe-optim-content">
                <Carousel
			        v-model="value"
			        :autoplay="setting.autoplay"
			        :autoplay-speed="setting.autoplaySpeed"
			        :dots="setting.dots"
			        :radius-dot="setting.radiusDot"
			        :trigger="setting.trigger"
			        :arrow="setting.arrow"
					:height="480"
			        >
			        <CarouselItem v-for="ch in list " :key="ch.key">
			        	<router-link v-for="(item,index) in ch.children" :key="item.aid"  class="goods-item" :to="item.url" target="_blank">
							<img class="img-item" :src="item.atturl" :alt="item.aname" />
					 	</router-link>
			        </CarouselItem>
			    </Carousel>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
	props:["data"],
	data() {
		let _list = this.data;
		let temp = [];
		for(let i=0,len=_list.length;i<len;i++){
			let index = parseInt(i/5);
			temp[index] = temp[index] || {};
			temp[index].key=index;
			temp[index].children=temp[index].children||[];
			temp[index].children.push( _list[i] )
		}
	    return {
	        list : temp,
	        value: 0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'none',
                radiusDot: false,
                trigger: 'hover',
                arrow: 'hover'
            }
	    }
	}
}
</script>



// WEBPACK FOOTER //
// boutique-discount.vue?949f1b1a